import { useState } from 'react';
import { onModelChange } from './util';

export const useForm = (formData, props) => {
	const [data, setData] = useState(formData);

	const onChange = (e, key) => {
		const changed = onModelChange(data, e, key);
		props?.onChange?.(changed);
		setData(changed);
		return changed[key];
	}
	return { data, setData, onChange };
};